import { Toast } from "primereact/toast";
import { useSession } from "../assets/auth/SessionContext";
import { useEffect, useRef, useState } from "react";
import { postData, putData } from "../services/api";

export default function EditTicketModal(modalData: any) {

    const { session } = useSession();

    const [formData, setFormData] = useState(modalData.selectedDataItem);
    const [modalHeader, setModalHeader] = useState("");

    const toast = useRef<Toast>(null);

    useEffect(() => {
        setModalHeader("Edit ticket")
    }, []);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prevFormData: any) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleResend = (data: any) => {
        putData(session, `tickets/${formData.ref}`, { displayName: formData.displayName, email: formData.email }, "").then(data => {

            postData(session, `tickets/resend`, { ref: formData.ref, email: formData.email }, null).then(resend => {

                modalData.closeModal({ severity: "success", summary: `E-Mail sent to ${formData.email}` });

            }).catch(err => {
                if (toast.current) {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: err.message });
                }
            });
        }).catch(err => {
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: err.message });
            }
        });
    }

    const handleSave = (data: any) => {
        putData(session, `tickets/${formData.ref}`, { displayName: formData.displayName, email: formData.email }, "").then(data => {

            modalData.closeModal({ severity: "success", summary: `Saved!` });

        }).catch(err => {
            if (toast.current) {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: err.message });
            }
        });
    }

    return (
        <div className="modal-container">

            <Toast ref={toast} />
            <div className="modal">
                <div className="modal-header">
                    <span className="modal-title">{modalHeader}</span>
                    <span className="modal-close" onClick={modalData.closeModal}>&times;</span>
                </div>

                <div className="flex">
                    <div className="flex-1 flex m-2 px-5 py-3 ">
                        <label className="text-label" htmlFor="ref">Display Name</label>
                        <input
                            className="text-input"
                            type="text"
                            id="displayName"
                            name="displayName"
                            value={formData.displayName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="flex-1 flex m-2 px-5 py-3 ">
                        <label className="text-label" htmlFor="level">E-Mail</label>
                        <input
                            className="text-input"
                            type="text"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="footer">
                    <button type="button" className="save-button" onClick={handleSave} >Save</button>
                    <button type="button" className="cancel-button" style={{ backgroundColor: "#007bff" }} onClick={handleResend} >Send Ticket</button>
                    <button type="button" className="cancel-button" onClick={modalData.closeModal}>Cancel</button>
                </div>
            </div>
        </div >
    );
}
